import React from 'react';
import './ErrorAlert.css';

/**
 * Reusable error alert component
 */
const ErrorAlert = ({ 
  error, 
  onDismiss, 
  type = 'danger',
  dismissible = true,
  className = ''
}) => {
  if (!error) return null;

  const alertClass = `alert alert-${type} ${dismissible ? 'alert-dismissible' : ''} ${className}`;

  return (
    <div className={alertClass} role="alert">
      <div className="alert-content">
        <strong>Error:</strong> {error}
      </div>
      {dismissible && onDismiss && (
        <button 
          type="button" 
          className="btn-close" 
          aria-label="Close"
          onClick={onDismiss}
        >
          <span aria-hidden="true">&times;</span>
        </button>
      )}
    </div>
  );
};

export default ErrorAlert;
